import { defineField, NumberRule } from "sanity";
import { currencies, Currency } from "../../common/currencies";
const DEFAULT_CURRENCY = currencies.find((lang) => lang.value === "USD")!;

const NON_DEFAULT_CURRENCIES = currencies.filter(
  (lang) => lang.value !== DEFAULT_CURRENCY.value
);

const firstValidCurrency = (selection: MultiCurrencyPercentage) =>
  currencies.reduce<string | undefined>((s, i) => {
    if (s) return s.toString();
    const value = selection[i.value];
    if (value) return `${value}% ${i.title}`;
  }, undefined);

export type MultiCurrencyPercentage = {
  _type: "multiCurrencyPercentage";
} & CurrencyValueType<number>;

type CurrencyValueType<T> = {
  [K in Currency]?: T;
};

const validation = (Rule: NumberRule) => Rule.required() && Rule.greaterThan(0);

export default defineField({
  name: "multiCurrencyPercentage",
  title: "Multi-currency Percentage",
  type: "object",
  fields: [
    defineField({
      title: DEFAULT_CURRENCY.title,
      name: DEFAULT_CURRENCY.value,
      type: "number",
      validation
    }),
    ...NON_DEFAULT_CURRENCIES.map((lang) =>
      defineField({
        title: lang.title,
        name: lang.value,
        type: "number",
        validation
      })
    )
  ]
});

export function multiCurrencyPercentagePreview(value: MultiCurrencyPercentage) {
  return firstValidCurrency(value);
}
